// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-simple-layout'
});
// #endregion
